import { Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import moment from "moment";
import { useMemo } from "react";
import { MovimentacaoBancariaItem } from "core/features/movimentacoes-bancarias/typings";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { OperacaoEnum } from "core/resources/enums/conta";
import colors from "core/resources/theme/colors";

function useMovimentacoesBancariasColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data",
        render: (original: MovimentacaoBancariaItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {moment(original.dataMovimentacao).format("DD/MM/YYYY")}
          </Text>
        ),
      },
      {
        title: "Descrição",
        render: (original: MovimentacaoBancariaItem) => (
          <Text fontSize={14} lineHeight={"18px"}>
            <Flex flex={1}> {original.descricao} </Flex>
          </Text>
        ),
      },
      // {
      //   title: "Categoria",
      //   render: (original: MovimentacaoBancariaItem) => (
      //     <Text fontSize={14} lineHeight={"18px"}>
      //       <Flex flex={1}> {original.categoria}</Flex>
      //     </Text>
      //   ),
      // },
      {
        title: "Valor",
        render: (original: MovimentacaoBancariaItem) => (
          <Text
            fontSize={14}
            lineHeight={"18px"}
            color={
              original.operacao === OperacaoEnum.Despesa
                ? colors.red
                : undefined
            }
          >
            <Flex flex={1}>
              R$ {formatCurrency(original.valorLiquido ?? original.valor)}
            </Flex>
          </Text>
        ),
      },
      {
        title: "Conciliado ?",
        render: (original: MovimentacaoBancariaItem) => (
          <Text fontSize={14} lineHeight={"18px"}>
            <Flex flex={1}> {original.conciliado ? "Sim" : "Não"}</Flex>
          </Text>
        ),
      },
      {
        title: "Saldo",
        render: (original: MovimentacaoBancariaItem) => (
          <Text fontSize={14} lineHeight={"18px"}>
            <Flex flex={1}>
              {original.saldo ? "R$ " + formatCurrency(original.saldo) : "--"}
            </Flex>
          </Text>
        ),
      },
    ];
  }, []);
}

export default useMovimentacoesBancariasColumns;
